const formatErrorMessage = (intl, label, errorType = 'empty') => {
  const message = []

  if (label) {
    message.push(intl.formatMessage({ id: `contactRequestForm.${label}` }))
  }

  message.push(intl.formatMessage({ id: `errors.${errorType}` }))

  return message.join(' ')
}

export {
  formatErrorMessage,
}
